module.exports = __webpack_public_path__ + "img/document-verified-warning.8db11348.svg";